module.exports = __webpack_public_path__ + "static/media/feature-6.90a65f21.png";